import { MCP_CLIENT_SETUP } from '../../constants/mcp-content';
import {
	SECTION_CLASS,
	SECTION_HEADING_CLASS,
	SECTION_LEAD_CLASS,
} from '../../constants/section-classes';

/** Per-client connection steps, kept short. */
export const McpClientSetupSection = () => {
	return (
		<section className={SECTION_CLASS}>
			<div className="mx-auto max-w-4xl">
				<div className="mb-10 md:mb-12">
					<h2 className={SECTION_HEADING_CLASS}>Set up by client</h2>
					<p className={SECTION_LEAD_CLASS}>
						Add Binary as a remote MCP server, then sign in with your Binary account. Menu names
						can change between client versions.
					</p>
				</div>

				<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
					{MCP_CLIENT_SETUP.map((entry) => (
						<div
							key={entry.client}
							className="flex flex-col gap-3 rounded-xl border border-border bg-background p-5"
						>
							<h3 className="text-base font-semibold text-primary md:text-lg">
								Binary in {entry.client}
							</h3>
							<ol className="flex list-decimal flex-col gap-2 pl-5 text-sm leading-relaxed text-secondary md:text-[15px]">
								{entry.steps.map((step) => (
									<li key={step}>{step}</li>
								))}
							</ol>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};
